import ButtonLoader from './ButtonLoader.vue';

export default ButtonLoader;



// WEBPACK FOOTER //
// ./src/pages/profile/components/button/components/loader/index.ts